import { useEffect, useState } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import PageContainer from "../../Components/Page/PageContainer";
import { TabMenu } from "primereact/tabmenu";
import { Card } from "primereact/card";
import { ROUTES } from "../../config/routes";

const TAB_PATHS = [
  ROUTES.OAC_AUDIT,
  ROUTES.OAC_AUDIT_CHANNEL_SETTINGS,
  ROUTES.OAC_AUDIT_PLAYLISTS,
];

const OACAudit = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const path = location.pathname;
    if (path.includes(ROUTES.OAC_AUDIT_PLAYLISTS)) {
      setActiveIndex(2);
    } else if (path.includes(ROUTES.OAC_AUDIT_CHANNEL_SETTINGS)) {
      setActiveIndex(1);
    } else {
      setActiveIndex(0);
    }
  }, [location.pathname]);

  const handleTabChange = (e: { index: number }) => {
    setActiveIndex(e.index);
    navigate(TAB_PATHS[e.index]);
  };

  const items = [
    { label: "OAC Audit", icon: "pi pi-list-check" },
    { label: "Channel Settings", icon: "pi pi-cog" },
    { label: "Create Playlist", icon: "pi pi-list" },
  ];

  return (
    <PageContainer
      HomeMenuBarprops={{
        title: (
          <span
            style={{ cursor: "pointer", fontWeight: "bold" }}
            onClick={() => navigate(ROUTES.OAC_AUDIT)}
          >
            OAC Audit
          </span>
        ),
        Tabs: (
          <TabMenu
            activeIndex={activeIndex}
            onTabChange={handleTabChange}
            model={items}
          />
        ),
      }}
    >
      <div style={{ width: "96%", margin: "0 auto" }}>
        <Card unstyled style={{ marginTop: "2rem", boxShadow: "none" }}>
          <Outlet />
        </Card>
      </div>
    </PageContainer>
  );
};

export default OACAudit;
